import { render, staticRenderFns } from "./BCGovNavBar.vue?vue&type=template&id=bfc9f1ca&scoped=true"
import script from "./BCGovNavBar.vue?vue&type=script&lang=js"
export * from "./BCGovNavBar.vue?vue&type=script&lang=js"
import style0 from "./BCGovNavBar.vue?vue&type=style&index=0&id=bfc9f1ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc9f1ca",
  null
  
)

export default component.exports